import { registerDecorator, ValidationOptions } from 'class-validator';
import { isBefore, isValid } from 'date-fns';

export function IsPastDate(validationOptions?: ValidationOptions) {
	return function (object: object, propertyName: string) {
		registerDecorator({
			name: 'isPastDate',
			target: object.constructor,
			propertyName,
			constraints: [],
			options: {
				...validationOptions,
				message: validationOptions?.message ?? 'Date must be in the past',
			},
			validator: {
				validate(value: string | Date) {
					const providedDate = new Date(value);
					if (!isValid(providedDate)) return false;

					const now = new Date();

					return isBefore(providedDate, now);
				},
			},
		});
	};
}
